import { URSSAF } from '@/utils/logos'

export const docDeclarerRevenusFrontalierSuisse = {
	url: 'https://www.urssaf.fr/accueil/services/services-particuliers/travailleur-frontalier-suisse/declarer-revenus-frontalier.html',
	title: 'Déclarer vos revenus annuels',
	description:
		'Comment déclarer vos revenus annuels sur urssaf.fr, étape par étape.',
	logo: URSSAF,
}
